function initLightbox() {
    const lightbox = document.querySelector('.js-lightbox');
    const lightboxClose = document.querySelector('.js-lightbox-close');
    const targets = document.querySelectorAll('.js-lightbox-target');

    if(targets && targets.length > 0) {
        targets.forEach(target => {
            fetch(target.dataset.image).then(function(response) {
                // The fetch was successful!
                const image = new Image();
                image.src = response.url;

                lightbox.appendChild(image);

                target.classList.add('image-loaded');

                target.addEventListener('click', () => {
                    const images = lightbox.querySelectorAll('img');

                    images.forEach(image => {
                        image.classList.remove('show');

                        if(image.src === target.dataset.image) {
                            lightbox.classList.add('open');
                            image.classList.add('show');
                        }
                    });
                });
            }).catch(function (error) {
                // There was an error
                console.warn('Something went wrong.', error);
            });
        })

        lightboxClose.addEventListener('click', () => {
            if(lightbox.classList.contains('open')) {
                const images = lightbox.querySelectorAll('img');
                lightbox.classList.remove('open');

                setTimeout(() => {
                    images.forEach(image => {
                        image.classList.remove('show');
                    });
                }, 200);
            }
        });
    }
}
